!function() {
  class e extends HTMLElement {
    constructor() {
      super(), Shopify = Shopify || {}, Shopify.recentlyViewed = JSON.parse(localStorage.getItem("recentlyViewed")) || [], 
      this.container = this.querySelector("[data-slider]");
    }
    connectedCallback() {
      this.container && Shopify.recentlyViewed && Shopify?.recentlyViewed?.length > 0 && this.loadProducts();
    }
    loadProducts() {
      Shopify.recentlyViewed.forEach((e => this.loadProduct(e.split("#")[0])));
    }
    show() {
      this.classList.remove("hidden");
    }
    removeItem(e) {
      Shopify.recentlyViewed = Shopify.recentlyViewed.filter((t => t !== e)), localStorage.setItem("recentlyViewed", JSON.stringify(Shopify.recentlyViewed));
    }
    async loadProduct(e) {
      const t = location.href.match("/products/([^?]+)");
      t && e === t[1] || fetch(`${window.Shopify?.routes?.root || "/"}products/${e}?view=card`).then((t => {
        if (!t.ok) throw this.removeItem(e), Error(t.statusText);
        return t.text();
      })).then((t => {
        const r = (new DOMParser).parseFromString(t, "text/html");
        if (1 !== r.querySelectorAll("product-card").length) throw this.removeItem(e), Error(response.statusText);
        {
          const e = document.createElement("div");
          e.classList.add("shrink-0", "snap-start", "w-grid"), e.setAttribute("data-slide", !0), 
          e.innerHTML = r.body.innerHTML, this.container.appendChild(e);
        }
      })).then((() => {
        this.show();
      })).catch((t => {
        console.warn("Could not load product: " + e + ". " + t);
      }));
    }
  }
  customElements.get("recently-viewed") || customElements.define("recently-viewed", e);
}();